import { Component, computed, inject, signal } from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import { APP_LANGUAGES, AppLanguage } from '../../../i18n/languages';
import { TranslateService } from '../../../i18n/translate.service';

@Component({
    selector: 'app-language-switcher',
    imports: [PopoverModule],
    templateUrl: './language-switcher.html',
})
export class LanguageSwitcher {
    readonly i18n = inject(TranslateService);
    readonly languages = APP_LANGUAGES;
    readonly open = signal(false);
    readonly currentLabel = computed(
        () => this.languages.find((lang) => lang.code === this.i18n.language())?.label ?? 'English',
    );

    select(code: AppLanguage, popover: Popover) {
        this.i18n.setLanguage(code);
        popover.hide();
    }
}